define('boxes/deposit-box',['jquery', 'payment/depositAmounts', 'boxes/events/bonus-event', 'payment/depositFee', 'boxes/helpers/message-popup',
	'boxes/events/paymentEvent', 'boxes/box', 'all/comeon', 'boxes/helpers/box-loading', 'boxes/events/feeEvent', 'boxes/helpers/formValidation',
    'boxes/helpers/payment-helpers', 'payment/templates/form-template', 'boxes/events/controller-event', 'all/player/session', 'all/tracking-event',
	'boxes/helpers/middle-bar-helper', 'payment/paymentOperationMetadata', 'boxes/helpers/uk-deposit-limit', 'all/paymentServices-toggles',
	'all/jquery/jquery.mustache'], function ($, depositAmounts, bonusEvent, depositFee, messagePopup, paymentEvent, box, comeon, boxLoading, feeEvent,
                                             formValidation, payments, formTemplate, controllerEvent, session, trackingEvent, middleBarHelper,
                                             paymentOperationMetadata, ukDepositLimit, paymentServicesToggles) {
	'use strict';

	function setupControllerEventHandlers(depositBox) {
		depositFee.init(depositBox);
		depositBox.$controller.on(bonusEvent.BONUS_CHANGED, function (event, bonus) {
			if (bonus.isFree === true) {
				depositBox.model.isFreeMoneyBonusSelected = true;
				return;
			}
            depositBox.model.isFreeMoneyBonusSelected = false;
			depositBox.model.isShopBonus = bonus.isShop;
			depositBox.model.bonusData = bonus;
		});

		depositBox.$controller.on(bonusEvent.NO_SELECTED_BONUS, function () {
			function removeAllData($element) {
				var i,
					data = $element.data(),
					keys = $.map(data, function (value, key) {
						return key;
					});

				for (i = 0; i < keys.length; i++) {
					$element.removeData(keys[i]);
				}
			}
			depositBox.model.bonusData = undefined;
			depositBox.model.isFreeMoneyBonusSelected = false;
			depositBox.model.isShopBonus = false;

			var $selectedBonus = depositBox.$box.find('.selected-bonus');
			removeAllData($selectedBonus);
			$selectedBonus.hide();
		});

		depositBox.$controller.on(paymentEvent.SHOW_FAIL_MESSAGE, function (event, failMessage) {
			boxLoading.removeLoading(depositBox.$box);
			showDepositFailMessage(depositBox, failMessage);
		});

		depositBox.$controller.on(paymentEvent.REMOVE_LOADING, function () {
			boxLoading.removeLoading(depositBox.$box);
		});

		depositBox.$controller.on(paymentEvent.UPDATE_AMOUNT, function (event, data) {
			depositBox.model.instantDepositAmount = data.amount;
		});

		depositBox.$controller.on(feeEvent.RESET_FEE, function (event, data) {
			depositFee.resetFees(data.selectedId, data.currency, data.bonusId, data.formTemplateCode, data.aid, data.amount);
		});

		depositBox.$controller.on(feeEvent.UPDATE_FEE, function (event, data) {
			depositFee.updateFeesBox(
				data.selectedFormMethodId,
				data.amount,
				data.selectedCurrency,
				data.bonusId,
				data.formTemplateCode,
				data.aid);
		});

		depositBox.$controller.on(feeEvent.UPDATE_TOOLTIP, function (event, data) {
			formValidation.updateFeeTooltip(data, depositBox);
		});

		depositBox.$controller.on(feeEvent.UPDATE_FEEOVER, function (event, data) {
			formValidation.updateFeeOver(data, depositBox);
		});

		depositBox.$controller.on(paymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED, function (event) {
			event.preventDefault();
			if (ukDepositLimit.depositLimitChosen()) {
				ukDepositLimit.setDailyLimit(depositBox);
			}
			reset(depositBox);
		});

		depositBox.$controller.on(paymentEvent.PENDING, function (event) {
			event.preventDefault();
			if (ukDepositLimit.depositLimitChosen()) {
				ukDepositLimit.setDailyLimit(depositBox);
			}
		});

		depositBox.$controller.on('SHOW_MESSAGE_SUCCESS', function () {
			var $skipDepositBoxButton = middleBarHelper.findMiddleBar(depositBox, 'skip-deposit');
			$skipDepositBoxButton.off('click').on('click', function(e) {
				e.preventDefault();

				if(typeof($.cookie('lastProduct')) !== 'undefined') {
					location.reload();
				} else {
					depositBox.$controller.trigger('no-deposit');
					depositBox.$controller.nextBox();
				}
			});
			depositBox.model.showSkipButton = true;
		});
	}

	function reset(depositBox) {
		getPaymentMethodsAndInitializeBox(depositBox, true);
	}

	function setupDepositButton(depositBox) {
		var depositButton = depositBox.$box.find('.deposit-button');
		depositButton.off('click').on('click', function () {
				if (formValidation.valid() && ukDepositLimit.validateLimitField()) {
					disableDepositButton(depositBox);
					if (isPaymentMethodIncludedInBonus(depositBox)) {
						depositBox.model.paymentController.sendPayment(depositBox);
					} else {
						showPaymentMethodNotIncludedPopup(depositBox);
					}
				}
			}
		);
	}

	function setupCheckAmountWithBox(depositBox) {
		var $activeButton;
		var $amountButtons = depositBox.$box.find('.btn');

		var $amountField = payments.getAmountInputField(depositBox);
		$amountField.on('change', function () {
			var amounts = depositAmounts.amountsMap();
			var value = parseFloat(this.value);
			if (amounts.hasOwnProperty(value)) {
				$amountButtons.filter('.active').removeClass('active');
				var $inputs = $amountButtons.find('input');
				$activeButton = $inputs.filter('input[value=' + value + ']');
				$activeButton.parent().addClass('active');
			} else {
				$activeButton = $amountButtons.filter('.active');
				$activeButton.removeClass('active');
			}
		});
	}

	function setDepositButtonDisabled(depositBox, booleanDisable) { // Hungarian notation makes sense in a typeless world
		var depositButton = depositBox.$box.find('.deposit-button');
		depositButton.prop('disabled', booleanDisable);
	}

	function enableDepositButton(depositBox) {
		setDepositButtonDisabled(depositBox, false);
	}

	function disableDepositButton(depositBox) {
		setDepositButtonDisabled(depositBox, true);
	}

	function initEventHandlerElements(depositBox) {
		enableDepositButton(depositBox);
	}

	function setupBoxHeaderText(paymentBox, formTemplate) {
		var boxHeaderText;
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			boxHeaderText = formTemplate.paymentMethod.boxHeaderText;
		} else {
			boxHeaderText = formTemplate.paymentMethod.extraParameters.boxHeaderText;
		}
		var $headerElement = paymentBox.$box.find('#deposit-box-header-text');
		if (boxHeaderText === undefined) {
			boxHeaderText = $headerElement.data('default');
		}
		$headerElement.html(boxHeaderText);
	}

	function setupDepositButtonText(paymentBox, formTemplate) {
		var depositButtonText;
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			depositButtonText = formTemplate.paymentMethod.depositButtonText;
		} else {
			depositButtonText = formTemplate.paymentMethod.extraParameters.depositButtonText;
		}
		var $depositButton = paymentBox.$box.find('.deposit-button');
		if (depositButtonText === undefined) {
			depositButtonText = $depositButton.data('default');
		}
		$depositButton.html(depositButtonText);
	}

	function setupDropdownOnChange(paymentBox) {
		var $paymentMethodSelectionBox = paymentBox.$box.find('select.payment-methods');
		$paymentMethodSelectionBox.on('change', function () {
			var controller = paymentBox.model.paymentController;
			var selectedFormTemplate = controller.getSelectedFormTemplate();

			setupDepositButtonText(paymentBox, selectedFormTemplate);
			setupBoxHeaderText(paymentBox, selectedFormTemplate);
		});
	}

	function setupUIDepositEventHandlers(depositBox) {
		initEventHandlerElements(depositBox);
		setupDepositButton(depositBox);
		setupDropdownOnChange(depositBox);
		setupCheckAmountWithBox(depositBox);
	}

	function isPaymentMethodIncludedInBonus(depositBox) {
		if (typeof(depositBox.model.bonusData) === 'undefined') {
			return true;
		}
		var $selectedBonus = depositBox.$box.find('.selected-bonus');
		var includedPaymentMethodIdsData = $selectedBonus.data('included-payment-method-ids');
		if (typeof(includedPaymentMethodIdsData) === 'undefined' || includedPaymentMethodIdsData === '' || includedPaymentMethodIdsData.length < 1) {
			return true;
		}
		var includedPaymentMethodIds = (includedPaymentMethodIdsData + ',').split(',');
		var selectedPaymentMethodId = depositBox.$box.find('.payment-methods').val();
		for (var i = 0; i < includedPaymentMethodIds.length; i++) {
			if (includedPaymentMethodIds[i] === selectedPaymentMethodId) {
				return true;
			}
		}
		return false;
	}

	function showPaymentMethodNotIncludedPopup(depositBox) {
		var $bonusDiv = depositBox.$box.find('.selected-bonus');

		var callbacks = {
			closeButtonCallback: function(e){
				e.preventDefault();
				enableDepositButton(depositBox);
			},
			confirmButtonCallback: function (e) {
				e.preventDefault();
				$bonusDiv.data('bonus-id', '');
				depositBox.$controller.trigger(bonusEvent.NO_SELECTED_BONUS);
				depositBox.$box.find('.overlay').remove();
				depositBox.model.paymentController.sendPayment(depositBox);
				disableDepositButton(depositBox);
			}
		};

		var paymentMethodName = depositBox.$box.find('.payment-methods option:selected').text();
		messagePopup.show(depositBox.$box, 'message-popup', {
				title: $bonusDiv.data('paymentMethodNotIncludedHeader'),
				message: $bonusDiv.data('paymentMethodNotIncludedMessage'),
				confirmButtonText: $bonusDiv.data('usePaymentMethodAnywayButtonPrefix') + ' ' + paymentMethodName + ' ' + $bonusDiv.data('usePaymentMethodAnywayButtonPostfix'),
				closeButtonText: $bonusDiv.data('closeButtonText')
			},
			callbacks
		);
	}

	function showDepositFailMessage(depositBox, failMessage) {

		function addFailedTrackingEvent(depositBox, selectedPaymentMethodId) {
			if (!depositBox.$box.data('trackingName') || !depositBox.$controller.$controller.data('trackingName')) {
				return;
			}

			trackingEvent.add(
				depositBox.$controller.$controller.data('trackingName'),
				depositBox.$box.data('trackingName'),
				'Deposit failed, payment method id = ' + selectedPaymentMethodId
			);
		}

		var title = 'Ops';
		var message = 'Ops';
		if (typeof failMessage !== 'undefined' && typeof failMessage.title !== 'undefined' && typeof failMessage.message !== 'undefined') {
			title = failMessage.title;
			message = failMessage.message;
		}
		var selectedPaymentMethodId = depositBox.$box.find('.payment-methods').val();
		addFailedTrackingEvent(depositBox, selectedPaymentMethodId);
		$.post('/PaymentFormDataService/GetAlternativePaymentMethod', {paymentMethodId: selectedPaymentMethodId}, function (data) {
			if (data !== null && data.alternativePaymentExist) {
				var alternativePaymentMethodId = data.alternativePaymentMethodId;

				var callbacks = {
					confirmButtonCallback: function () {
						confirmButtonCallback(depositBox, alternativePaymentMethodId);
					}
				};

				messagePopup.show(depositBox.$box, 'message-popup', {
						title: title,
						message: message,
						confirmButtonText: data.tryButtonText
					},
					callbacks
				);
			} else {
				messagePopup.show(depositBox.$box, 'message-popup', {
						title: title,
						message: message
					}
				);
			}
		});

		enableDepositButton(depositBox);
	}

	function confirmButtonCallback(depositBox, alternativePaymentMethodId) {
		depositBox.$box.find('.payment-methods').val(alternativePaymentMethodId).change();
		depositBox.$box.find('.overlay').hide();
	}

	function isFreeMoneyBonusSelectedPromise(depositBox) {
		var freeMoneyBonusSelectedPromise = comeon.promise.create();
		if (depositBox.model.isFreeMoneyBonusSelected) {
			freeMoneyBonusSelectedPromise.reject();
		} else {
			freeMoneyBonusSelectedPromise.resolve();
		}
		return freeMoneyBonusSelectedPromise.promise();
	}

	function setupInstantDepositAmount(depositBox, hasPaymentMethodsPromise) {
		var hasSetupInstantDepositAmountPromise = comeon.promise.create();
		$.when(hasPaymentMethodsPromise)
			.done(function () {
					if (depositBox.model.instantDepositAmount !== undefined) {
						depositBox.model.paymentController.selectedAmount = depositBox.model.instantDepositAmount;
						depositBox.model.instantDepositAmount = undefined;
					}
					hasSetupInstantDepositAmountPromise.resolve();
				}
			);
		return hasSetupInstantDepositAmountPromise.promise();
	}

	function renderBonus(depositBox) {
		if (typeof(depositBox.model.bonusData) === 'undefined') {
			return;
		}
		var $selectedBonus = depositBox.$box.find('.selected-bonus');
		$selectedBonus.data('bonus-id', depositBox.model.bonusData.id);
		$selectedBonus.data('included-payment-method-ids', depositBox.model.bonusData.includedPaymentMethodIds);
		$selectedBonus.find('img').attr('src', depositBox.model.bonusData.resourceUrl);
		$selectedBonus.show();
		if (depositBox.model.isShopBonus) {
			var $selectedBonusButtons = depositBox.$box.find('.selected-bonus span.s12-change').parent();
			$selectedBonusButtons.off('click').on('.click', function () {
				$('#sliding-content-wrapper').find('.close').click();
			});
		} else {
			bonusEvent.changeBonusHandler(depositBox.$controller, depositBox.$box, depositBox.model.bonusData);
		}
	}

	function renderDepositBoxHeaderTitle(depositBox) {
		if (depositBox.model.paymentController.isFirstDeposit === true) {
			depositBox.$box.find('#deposit-box-header-title-first-deposit').show();
			depositBox.$box.find('#deposit-box-header-title').hide();
		} else {
			depositBox.$box.find('#deposit-box-header-title-first-deposit').hide();
			depositBox.$box.find('#deposit-box-header-title').show();
		}
	}

	function getPaymentMethodsAndInitializeBox(depositBox, forceLoadInSynch) {
		var url = '/PaymentFormDataService/getDepositPaymentMethods';
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			url = '/pp?flow=GetDepositPaymentMethods';
		}
		depositBox.model.hasPaymentMethodsPromise = payments.getPaymentMethods('DEPOSIT', depositBox, url, forceLoadInSynch);
	}

	var HTML = {method: 'html'},
		view = {
			render: function (depositBox) {
				depositBox.$box.find('.method').empty();
				var mustacheTemplateId = 'payment-method-template';
				$.Mustache.addFromDom(mustacheTemplateId);
				depositBox.$box.find('.method').mustache('payment-method-template', {templates: depositBox.model.paymentController.formTemplates}, HTML);

				renderBonus(depositBox);
				renderDepositBoxHeaderTitle(depositBox);

				if (depositBox.model.showSkipButton) {
					middleBarHelper.show(depositBox, 'skip-deposit');
				}
			}
		},
		model = {
			paymentController: undefined,
			instantDepositAmount: undefined,
			isFreeMoneyBonusSelected: false,
			isShopBonus: false,
			providerId: undefined,
			bonusData: undefined,
			hasPaymentMethodsPromise: undefined,
			showSkipButton: false,
			init: function (depositBox) {
				if (!session.authenticated) {
					$(session).on('login', function () {
						depositBox.model.init(depositBox);
					});
				}
				setupControllerEventHandlers(depositBox);
			},
			beforeRender: function (depositBox) {
				if (session.authenticated) {
					depositBox.$box.find('.payment-method-form').hide();
					getPaymentMethodsAndInitializeBox(depositBox, false);
				}

				var hasInitSelectedFormTemplatePromise = payments.initSelectedFormTemplate(depositBox, depositBox.model.hasPaymentMethodsPromise);
				var hasSetupInstantDepositAmountPromise = setupInstantDepositAmount(depositBox, depositBox.model.hasPaymentMethodsPromise);
				var hasSelectedFreeMoneyBonusPromise = isFreeMoneyBonusSelectedPromise(depositBox);
				var shouldShowDepositLimit = ukDepositLimit.shouldShowDepositLimitOption(depositBox);
				paymentOperationMetadata.queryFirstPaymentOperation("deposit");

				return [hasInitSelectedFormTemplatePromise, hasSetupInstantDepositAmountPromise, hasSelectedFreeMoneyBonusPromise, shouldShowDepositLimit];
			},
			afterRender: function (depositBox) {
				depositBox.$box.find('.overlay').hide();
				payments.setupUIEventHandlers(depositBox);
				setupUIDepositEventHandlers(depositBox);
				payments.setupDefaultPaymentMethod(depositBox);
				ukDepositLimit.init(depositBox);
			},
			close: function (depositBox) {
				middleBarHelper.hide(depositBox, 'skip-deposit');
			},
			showFailMessage: function (depositBox, failMessage) {
				showDepositFailMessage(depositBox, failMessage);
			},
			showUKDepositTandCStatus: function (depositBox, popupMessage, doneCallback) {
				messagePopup.show(depositBox.$box, 'message-popup', popupMessage, doneCallback);
			},
			showVerifyAgePopup: function (depositBox, message, doneCallback) {
				enableDepositButton(depositBox);
				messagePopup.show(depositBox.$box, 'message-popup', message, doneCallback);
			},
			disableDepositButton : function(depositBox){
				disableDepositButton(depositBox);
			},
			enableDepositButton : function(depositBox){
				enableDepositButton(depositBox);
			}
		};

	return {
		create: function ($box, $controller) {
			return box.create($box, $controller, view, model);
		}
	};
});

